export default "__VITE_ASSET__DbesK5EL__"